/** @jsxImportSource @emotion/react */
import { Box, Checkbox, Chip, Input, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useRecoilState } from "recoil";
import { Exchange } from "../../config/types";
import { selectedExchangesState } from "../../state/app";
import { getStyles } from "./styles";

function ExchangeSelector() {
  const styles = getStyles()
  const [exchanges, setExchanges] = useRecoilState(selectedExchangesState)

  const handleChange = (event: SelectChangeEvent<Exchange[]>) => {
    const { target: { value }} = event;
    setExchanges(value as Exchange[]);
  };

  return (
    <Select
      multiple
      displayEmpty
      value={exchanges}
      onChange={handleChange}
      input={<Input disableUnderline />}
      renderValue={(selected) => (
        <Box css={styles.selector} display="flex">
          <Chip label={`${selected.length} xchg`} size="small" />
        </Box>
      )}
    >
      {Object.values(Exchange).map(exchange => (
        <MenuItem key={exchange} value={exchange}>
          <Checkbox checked={exchanges.includes(exchange)} />
          <Box>
            <Typography variant="body2">{exchange}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  )
}

export default ExchangeSelector
